import React,{useState} from 'react'
import { Container, Row, Col, Form, Button } from 'react-bootstrap'
import { Paper, Stack } from '@mui/material'
import {motion} from 'framer-motion'

const Register = ({title}) => {

    const [formData, setFormData] = useState({})

    const handleChange = (e)=>{
        const {name, value} = e.target
        setFormData((state)=>({
            ...state,
            [name]:value
        }))
    }

    const handleChangeCheckbox = (e)=>{
        const {name, checked} = e.target
        setFormData((state)=>({
            ...state,
            [name]:checked
        }))
    }

    const handleSubmit = (e)=>{
        e.preventDefault()
    }

    return (
        <>


                <motion.h4 style={{ textAlign: 'center' }}
                initial={{opacity:0, y:-20}}
                animate={{opacity:1, y:0}}
                transition={{duration:0.1}}
                >
                    Add {title}
                </motion.h4>
                <br/>

                <motion.div style={{ width: "100%", backgroundColor: "#DBDFEA99",padding:20, borderRadius:'10px', border:'none' }}
                initial={{opacity:0, y:10}}
                animate={{opacity:1, y:0}}
                transition={{duration:0.1, delay:0.1}}
                >
                    <Row>
                        <Col sm={4} >
                            <Form.Label>{title} Name*</Form.Label>
                            <Form.Control name='name' onChange={handleChange} value={formData.name || ''} type="" placeholder={`Enter ${title}`} />
                        </Col>
                        <Col sm={4}>
                            <Form.Label>Description</Form.Label>
                            <Form.Control name='description' onChange={handleChange} value={formData.description || ''} type="" placeholder='Enter Description' />
                        </Col>
                        <Col sm={2}>
                            <br/>
                            <Form.Label style={{cursor:'pointer', marginTop:11}}> <Form.Check name='status' checked={formData.status || false} onChange={handleChangeCheckbox} inline aria-label="option 1" size={100} />Status</Form.Label>
                        </Col>
                        <Col sm={2}>
                        <br/>
                            <Button variant="primary" onClick={handleSubmit}>Save</Button>
                        </Col>
                    </Row>
                </motion.div>

        </>
    )
}

export default Register